import React, { Fragment } from 'react'
import styled from 'styled-components'
// import PropTypes from 'prop-types'

import Center from '~/components/basic/Center'
import Seperator from '~/components/svg/Seperator'
import WHATS_NEXT_ITEMS from './whatsNextItems'

const ItemContainer = styled.div`
  color: ${props => props.theme.colors.text.label};
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  line-height: 1.4375rem;
  font-size: 1rem;
  max-width: 200px;
`

const SeperatorContainer = styled.div`
  margin: 1rem 0;
`

const MobileSubmissionComplete = () => {
  return (
    <Center>
      {WHATS_NEXT_ITEMS.sort((a, b) => a.mobileOrder - b.mobileOrder).map(
        (item, index) => {
          return (
            <Fragment key={item.altText}>
              <ItemContainer>
                <Center>
                  <img src={item.iconSrc} alt={item.altText} />
                </Center>
                {item.mobileText}
              </ItemContainer>
              {index !== WHATS_NEXT_ITEMS.length - 1 ? (
                <SeperatorContainer>
                  <Seperator />
                </SeperatorContainer>
              ) : null}
            </Fragment>
          )
        }
      )}
    </Center>
  )
}

export default MobileSubmissionComplete
